import React from 'react';
import TeamListingV2 from './listing/TeamListingV2';
import { TeamMemberList } from './listing/TeamMemberList';
import { Flag } from 'common-components/utils/launchdarkly/flag';

export const TeamListingViewV2 = () => {
  return <Flag flag='paginatedTeamListing' on={<TeamMemberList />} off={<TeamListingV2 />} />;
};
